// import store modules
import Vue from 'vue'
import Vuex from 'vuex';
Vue.use(Vuex)

import session from './modules/session'
import user from './modules/user/'
import project from './modules/project/'
import datasheet from './modules/datasheet/'
import about from './modules/about/'
import donate from './modules/donate/'
import contact from './modules/contact/'
import file from './modules/file/'
import observation from './modules/observation/'
import organization from './modules/organization'
import organization_projects from './modules/organization_projects'
import location from './modules/location'
import map from './modules/map'
import analysis from './modules/analysis';
import integration_airtable from './modules/integration_airtable';
import integration_scistarter from './modules/integration_scistarter';
import topics from './modules/topics';
import constants from './modules/constants';
import admin from './modules/admin';


// Add the modules in the store
const store = new Vuex.Store({
    modules: {
        session,
        user,
        project,
        datasheet,
        about,
        contact,
        donate,
        file,
        observation,
        organization,
        organization_projects,
        location,
        map, // Used to manage the map state for all places a map is used
        analysis,
        integration_airtable,
        integration_scistarter,
        topics,
        constants, // Centralized constants (action types, file status, etc.)
        admin,
        }
});

export default store
